// extracted by css-extract-rspack-plugin
export default {"cls1":"WorkCard-cls1_dfB","cls2":"WorkCard-cls2_TB5 WorkCard-cls1_dfB"};